import {Injectable} from '@angular/core';
import {
    WorkbenchPlugin,
    WorkbenchPluginId,
    ViewTemplateId,
    WorkbenchViewTemplateConfig,
    WorkbenchViewConfig, OpenVideoRecordingEvent, WorkbenchViewKind,
} from '../../shared/types';
import {Observable, of} from 'rxjs';
import {WorkbenchLayoutManager} from '../../shared/services/workbench-layout-manager.service';
import {WorkbenchContextService} from '../../shared/services/workbench-context.service';
import {ProjectId, VideoRecordingId} from '@webmate-web-core/shared/types/ids';
import _ from 'lodash';
import {CENTER_VIEW_CONTAINER_CONFIG, CENTER_VIEW_CONTAINER_ID} from '../../shared/components/viewcontainers/viewcontainers';
import {VideoViewConfig, WorkbenchVideoViewerComponent} from './workbench-video-viewer.component';
import {WorkbenchCommandRegistry} from '../../shared/services/workbench-command-registry.service';
import {InspectorService} from '../../shared/services/inspector.service';



@Injectable()
export class VideoRecordingPlugin extends WorkbenchPlugin {
    id: WorkbenchPluginId = 'video-recording';
    projectId: ProjectId;
    views: WorkbenchViewKind[];

    static readonly ViewTemplateId: ViewTemplateId = 'video-recording.video-recording-view-template';

    constructor(readonly layoutManager: WorkbenchLayoutManager,
                private readonly commandRegistry: WorkbenchCommandRegistry,
                private readonly inspectorService: InspectorService,
                private readonly workbenchContextService: WorkbenchContextService) {
        super(layoutManager);
        this.workbenchContextService.subscribeWorkbenchContext$().subscribe(context => this.projectId = context.project);

        const viewTemplate: WorkbenchViewTemplateConfig<VideoViewConfig> = {
            templateId: VideoRecordingPlugin.ViewTemplateId,
            component: WorkbenchVideoViewerComponent,
            defaultViewContainer: CENTER_VIEW_CONTAINER_ID,
            icon: {
                type: 'faIcon',
                instance: "video"
            },

            init: (d: {id?: VideoRecordingId, name: string, duration?: string, size?: string, format?: string, localVideoBlobId?: string}) => {
                let config = _.cloneDeep(viewTemplate) as WorkbenchViewConfig<VideoViewConfig>;
                if (d.localVideoBlobId) {
                    // Locally dropped file — derive a stable view ID from the blob ID so the
                    // same file doesn't open duplicate tabs after a reload.
                    config.id = 'video-recording.local-view.' + d.localVideoBlobId;
                } else {
                    config.id = 'video-recording.view' + d.id;
                }
                config.name = d.name;
                config.fromTemplate = VideoRecordingPlugin.ViewTemplateId; // important for layout persistence
                config.payload = {
                    data: {
                        videoId: d.id,
                        name: d.name,
                        duration: d.duration,
                        size: d.size,
                        format: d.format,
                        localVideoBlobId: d.localVideoBlobId,
                    }
                };
                return config as WorkbenchViewConfig<VideoViewConfig>;
            }
        };

        this.views = [viewTemplate];
    }

    onWorkbenchDestroy(): void {
    }

    onWorkbenchInit(): Observable<void> {
        this.layoutManager.registerViewContainer(CENTER_VIEW_CONTAINER_CONFIG);

        this.commandRegistry.registerCommand(
            "videoRecording:openVideoRecordingTools",
            {
                name: 'Open specific Tools for Video recordings',
            },
            (event: OpenVideoRecordingEvent) => {
                this.inspectorService.changeItem('VideoRecording');
                setTimeout(() => this.inspectorService.raiseInspectorEvent(event));
            }
        )

        return of(undefined);
    }
}
